import { render } from "./personal.vue?vue&type=template&id=054db706&scoped=true&ts=true"
import script from "./personal.vue?vue&type=script&lang=ts"
export * from "./personal.vue?vue&type=script&lang=ts"

import "./personal.vue?vue&type=style&index=0&id=054db706&scoped=true&lang=css"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054db706"]])

export default __exports__